import { render } from "./Jahresgaben.vue?vue&type=template&id=827376c4&scoped=true"
import script from "./Jahresgaben.vue?vue&type=script&lang=js"
export * from "./Jahresgaben.vue?vue&type=script&lang=js"

import "./Jahresgaben.vue?vue&type=style&index=0&id=827376c4&scoped=true&lang=css"

import exportComponent from "/home/jacques/development/kvhbf/frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-827376c4"]])

export default __exports__